export const getOptions = (element) => {
  let type = "carousel";
  if (element.classList.contains("productcontainer-grid")) {
    type = "grid";
  }

  const defaults = {
    "data-maxUnitsToDisplay": 8,
    "data-ctaTarget": "_self",
    "data-path": window.location.origin,
    "data-additional-query-string-parameters": "",
    "data-mobile-page-size": "",
  };

  const getValOrDefault = (key) => {
    key = key.toLowerCase();
    if (
      element.attributes[key] &&
      element.attributes[key].value !== undefined
    ) {
      return element.getAttribute(key);
    } else {
      return defaults[key];
    }
  };

  return {
    type: type,
    analyticsId: element.getAttribute("data-analyticsId"),
    maxUnitsToDisplay: getValOrDefault("data-maxUnitsToDisplay"),
    categoryId: element.getAttribute("data-categoryid"),
    headline: element.getAttribute("data-headline"),
    description: element.getAttribute("data-description"),
    testApiUrl: element.getAttribute("data-testapiurl"),
    path: `/api`,
    ctaText: element.getAttribute("data-ctaText"),
    ctaTarget: getValOrDefault("data-ctaTarget"),
    additionalQueryStringParameters: getValOrDefault("data-additional-query-string-parameters"),
    mobilePageSize: 2,
  };
};
